// 101 Real Estate SMA — Header JS
(function(){
  const header   = document.getElementById('re101-header');
  const drawer   = document.getElementById('re101-drawer');
  const burger   = document.getElementById('re101-burger');

  // Scroll
  function onScroll(){
    if(window.scrollY > 60){
      header.classList.remove('re101-transparent');
      header.classList.add('re101-solid');
    } else {
      header.classList.remove('re101-solid');
      header.classList.add('re101-transparent');
    }
  }
  window.addEventListener('scroll', onScroll, {passive:true});
  onScroll();

  // Abrir/Cerrar con hamburger toggle
  if(burger){
    burger.addEventListener('click', function(){
      if(drawer.classList.contains('re101-open')){
        drawer.classList.remove('re101-open');
        document.body.style.overflow = '';
      } else {
        drawer.classList.add('re101-open');
        document.body.style.overflow = 'hidden';
      }
    });
  }

  // Cerrar con ESC
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape'){
      drawer.classList.remove('re101-open');
      document.body.style.overflow = '';
    }
  });

  // Cerrar al tocar fuera del drawer
  document.addEventListener('click', function(e){
    if(
      drawer.classList.contains('re101-open') &&
      !drawer.contains(e.target) &&
      !burger.contains(e.target)
    ){
      drawer.classList.remove('re101-open');
      document.body.style.overflow = '';
    }
  });
// Auto-detectar idioma del navegador al entrar por primera vez
(function(){
  // Solo redirige una vez por sesión
  if(sessionStorage.getItem('re101-lang-set')) return;
  sessionStorage.setItem('re101-lang-set', '1');

  const browserLang = (navigator.language || navigator.userLanguage || '').toLowerCase();
  const isEnglish = browserLang.startsWith('en');
  const currentPath = window.location.pathname;
  const isOnEnglish = currentPath.startsWith('/en');

  if(isEnglish && !isOnEnglish){
    // Navegador en inglés y sitio en español → redirige a inglés
    window.location.replace('/en' + currentPath);
  } else if(!isEnglish && isOnEnglish){
    // Navegador en español y sitio en inglés → redirige a español
    window.location.replace(currentPath.replace(/^\/en/, '') || '/');
  }
})();
})();